import {
  FormField,
  FormGrid,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { useForm } from 'react-hook-form';

import { Secret } from 'apis/messengers';
import { HookFormText } from 'components/hookForm';

import styles from './messengerSecretModal.module.scss';

export type EditSecretModalComponentProps = {
  /** Whether the modal is open. */
  isOpen: boolean;
  /** Whether the form is submitting. */
  isSubmitting: boolean;
  /** Messenger secret. */
  secret: Secret;
  /**
   * Callback for editing secret.
   *
   * @param secret - Secret
   */
  onEdit: (secret: Secret) => void;
  /** Callback for hiding the modal. */
  hide: () => void;
};

/** Presentational component for editing messenger secret. */
export const EditSecretModalComponent = ({
  isOpen,
  isSubmitting,
  secret,
  onEdit,
  hide,
}: EditSecretModalComponentProps): JSX.Element => {
  const { control, handleSubmit } = useForm<Secret>({
    mode: 'all',
    defaultValues: secret,
  });

  return (
    <Modal isOpen={isOpen} onClose={hide} className={styles.modal}>
      <ModalHead
        className={styles.modalHeader}
        title="Edit key"
        onClose={hide}
      />

      <ModalBody className={styles.modalBody}>
        <FormGrid>
          <FormField>
            <HookFormText
              name="description"
              label="Key description"
              control={control}
              componentProps={{ autoFocus: true }}
              helpIcon={{
                tooltipClassName: styles.helpTooltip,
                text: (
                  <Text.Paragraph variant="2" color="white">
                    A description will help you identify your key.
                  </Text.Paragraph>
                ),
              }}
            />
          </FormField>
        </FormGrid>
      </ModalBody>

      <ModalFoot
        className={styles.modalFooter}
        cancelOnClick={hide}
        confirmName="Save"
        confirmOnClick={handleSubmit(onEdit)}
        confirmProps={{ disabled: isSubmitting }}
      />
    </Modal>
  );
};
